import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AnalyticsService } from "@gen/tracker/v1/analytics_connect";
import { DateRange, Pagination } from "@gen/tracker/v1/common_pb";

import { createClient } from "@/lib/connect";
import type { ConversionBasis } from "@/lib/period";
import { basisToProto } from "@/lib/services/analytics-service";
import { statsRowToNumbers } from "@/lib/services/reporting-schema-service";

const client = createClient(AnalyticsService);

/**
 * One campaign split by a single dimension through GetStreamBreakdown — the
 * reader that also knows the step-view dimensions (`branch`, `step`), which
 * the drilldown does not. value → that row's metrics. «Поток» reads the
 * branches' shows with it.
 */
export function useStreamBreakdown(p: { campaignId: string; dimension: string; from: string; to: string; tz: string; basis: ConversionBasis }) {
  return useQuery({
    queryKey: ["campaign-flow-breakdown", p] as const,
    enabled: !!p.campaignId,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const res = await client.getStreamBreakdown({
        streamId: p.campaignId,
        dateRange: new DateRange({ from: p.from, to: p.to, timezone: p.tz }),
        dimensionKey: p.dimension,
        pagination: new Pagination({ limit: 500, offset: 0 }),
        attributionBasis: basisToProto(p.basis),
      });
      return new Map(res.rows.map((r) => [r.dimensionValue, statsRowToNumbers(r.stats)] as const));
    },
  });
}
